import styled from "styled-components";
import SpacingBox from "../SpacingBox";

export const StyledLayout = styled(SpacingBox)`
    display: flex;
    justify-content: ${props => props.justify || "flex-start"};
    align-items: ${props => props.align || "stretch"};
    flex-direction: ${props => props.direction || "row"};
`;

export const StyledFlex = styled(SpacingBox)`
    flex: ${props => props.flex || 1};
    order: ${props => props.order || "unset"};
`;
